import { functions } from "./firebase/firebaseInit";
import { httpsCallable } from "@firebase/functions";

export const getReportData = async (filters, quantity, offset) => {
    const getCallsReport = httpsCallable(functions, "getCallsReport");
    const result = await getCallsReport({ filters, quantity, offset });
    return JSON.parse(result.data) || [];
};
